import { C } from '../../lib/tokens.js';

export function HelpdeskHomePage() {
  return <div style={{ flex: 1, overflow: 'auto', background: C.platinum }} />;
}
